<template>
  <div id="app">
    <router-view />
  </div>
</template>

<script>
import "animate.css";

export default {};
</script>

<style>
* {
  margin: 0;
  padding: 0;
  box-sizing: border-box;
}

html {
  max-width: 100vw;
  overflow-x: hidden;
}

:root {
  --verde: #cbe949;
  --morado: #7d35ff;
  --moradoClaro: #c9bbff;
  --gris: #e9edfa;
  --blanco: #ffffff;
  --negro: #000000;
}
</style>
